import { useMatches } from "@tanstack/react-router";
import { observer } from "mobx-react-lite";
import { type PropsWithChildren } from "react";

import { Children } from "src/components/RootLayoutChildren";
import { WorkoutItemsInsert } from "src/components/WorkoutItemsInsert";
import { useBaseStaticCtx } from "src/hooks/useBaseStaticCtx";
import { getLayoutSettings } from "src/staticData";
import { workoutItemsInsertContext } from "src/workouts/WorkoutItemsInsertContext";

import { LayoutSettingsContextProvider } from "./LayoutSettingsContext";

export const RootLayout = observer(function RootLayout(
  props: PropsWithChildren,
) {
  const matches = useMatches();
  const baseStaticCtx = useBaseStaticCtx();

  const layoutSettings = getLayoutSettings({
    matches: matches,
    ctx: baseStaticCtx,
  });

  return (
    <workoutItemsInsertContext.Provider value={WorkoutItemsInsert}>
      <LayoutSettingsContextProvider layoutSettings={layoutSettings}>
        <Children>{props.children}</Children>
      </LayoutSettingsContextProvider>
    </workoutItemsInsertContext.Provider>
  );
});
